











































































































import {Vue, Component} from 'vue-property-decorator';
import InspectionFirstStep from '@/views/Inspection/InspectionFirstStep.vue';
import InspectionSecondStep from '@/views/Inspection/InspectionSecondStep.vue';
import InspectionThirdStep from '@/views/Inspection/InspectionThirdStep.vue';
import InspectionFourthStep from '@/views/Inspection/InspectionFourthStep.vue';
import {mapActions, mapGetters} from 'vuex';
import {extractDetailsFromBase64} from '@/services/api/image';
import moment from 'moment';
import {API} from '@/services/api/api';

@Component({
  components: {
    InspectionFirstStep,
    InspectionSecondStep,
    InspectionThirdStep,
    InspectionFourthStep,
  },
  methods: {
    ...mapActions(['setInspectionData', 'showSuccessToast', 'showErrorToast']),
  },
  computed: {
    ...mapGetters(['getInspectionData']),
  },
  beforeRouteEnter(to, from, next) {
    next((vm: any) => {
      vm.prevRoute = from.path;
    });
  },
})
export default class InspectionPanel extends Vue {
  stepNumber: number = 1;
  prevRoute: any;
  isScreenLoading = false;
  getInspectionData: any;
  showSuccessToast: any;
  showErrorToast: any;
  btnLoader = false;
  canMappedData = false;
  inspectorId: number = null;

  imageData = [];

  stepsHeader = [
    {
      stepCount: 1,
      displayName: 'Select Inspection Point',
    },
    {stepCount: 2, displayName: 'Inspection Details'},
    {stepCount: 3, displayName: 'Select Recipient'},
    {stepCount: 4, displayName: 'Summary'},
  ];

  mounted() {
    const loggedInUser: any = sessionStorage.getItem('user');
    if (loggedInUser) {
      const parsedData = JSON.parse(loggedInUser);
      this.inspectorId = parsedData.internalId;
    }
  }
  closeLoader() {
    this.isScreenLoading = false;
  }

  increaseStep() {
    var validator;
    switch (this.stepNumber) {
      case 1:
        validator = this.$refs.firstStep;
        return validator.firstStepValidator();
      case 2:
        validator = this.$refs.secondStep;
        return validator.saveSecondStepData();
      case 3:
        validator = this.$refs.thirdStep;
        return validator.saveThirdStepData();
      default:
        break;
    }
  }

  decreaseStep() {
    this.canMappedData = true;
    this.stepNumber--;
  }

  switchScreen() {
    // this.canMappedData = false;

    this.stepNumber++;
  }

  async onCreateInspectionClick() {
    this.btnLoader = true;

    const firstStep = this.getInspectionData.firstStep;
    const secondStep = this.getInspectionData.secondStep;
    const attachment = this.getInspectionData.secondStep.attachment;

    var imageData = $.extend(true, [], attachment);

    imageData.forEach((data) => {
      data.filePath = extractDetailsFromBase64(data.filePath).url;
    });

    const thirdStep = this.getInspectionData.thirdStep;

    const params = {
      inspectionPoint: {
        shipId: firstStep.shipId,
        deckId: firstStep.deckId,
        location_X: firstStep.location_X,
        location_Y: firstStep.location_Y,
        isMisc: firstStep.isMisc,
        zoneMasterId: firstStep.zoneId,
        structure: firstStep.structure,
        frameSide: firstStep.frameSide,
        frameStart: firstStep.frameStart,
        frameEnd: firstStep.frameEnd,
      },
      inspectionDetail: {
        inspectionDate: moment(secondStep.inspectionDate).format('YYYY-MM-DDThh:mm:ss'),
        inspectionID: firstStep.inspectionCode,
        inspectorId: this.inspectorId,
        voyageData: secondStep.voyage,
        voyageConditionId: secondStep.voyageConditionId,
        findingsId: secondStep.findingId,
        frameNumber: secondStep.frame,
        dimentionLength: secondStep.length,
        lengthUnit: secondStep.lengthUnit,
        dimentionWidth: secondStep.width,
        widthUnit: secondStep.widthUnit,
        zoneMasterId: firstStep.zoneId,
        workOrder: secondStep.workOrder,
        severityId: secondStep.severityId,
        summary: secondStep.comment,
        reInspectionDate: moment(secondStep.reInspectionDate).format('YYYY-MM-DDThh:mm:ss'),
        isActionPlanRequired: secondStep.isActionPlanReq,
        isActive: true,
      },
      inspectionRecipient: {
        mailToUserId: thirdStep.mailToUserId,
        mailCcUserId: thirdStep.mailCcUserId,
        mailCcEmailAddress: thirdStep.mailCcEmailAddress,
      },
      inspectionAttachment: imageData,
    };

    try {
      const response = await API.createInspection(params);

      if (response.data) {
        // this.$router.push('/ship-inspection-list');
        const route = ['/inspection-list', '/inspection/action-plan'];
        if (route.includes(this.prevRoute)) {
          this.$router.go(-1);
        } else {
          this.$router.push('/inspection-list');
        }
        // this.prevRoute
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.btnLoader = false;
    }
  }

  onBackBtnClick() {
    this.$router.go(-1);
  }
}
